import { Modal } from "react-bootstrap";
import crossBlack from "../../../assets/images/onboardingImages/crossBlack.svg";
import CopyIcon from "../../../assets/images/Copy.svg";
import BubbleSvgButton from "../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import CheckIcon from "../../../assets/images/greenCheck.svg";
import "./tradesVerifiedInfoModal.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { userCommunity } from "../../../redux/community/communitySlice";
import { useDispatch, useSelector } from "react-redux";
import { globalCurrentPageTitle, paymentTypeAtom } from "../../../store/globalstore";
import { useAtom, useSetAtom } from "jotai";
import { resetOnBoardingStartContext } from "../../../redux/users/usersSlice";
import { showNotificationToast, toastify } from "../../../helpers/toast/toastify";

const TradesVerifiedInfoModal = ({
  setDisplayInfoModal,
  blockChainId,
  blockChainLink,
}) => {
  const user = useSelector((state) => state.user.user);
  const setPaymentType = useSetAtom(paymentTypeAtom);
  const [currentPageTitle, setCurrentPageTitle] = useAtom(
    globalCurrentPageTitle
  );
  
  const location = useLocation();
  const onBoardingStartContext = useSelector(
    (state) => state.user?.onBoardingStartContext
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <div className="onboarding-modal-wrapper">
      <Modal
        animation={false}
        backdropClassName="onboarding-custom-backdrop"
        centered
        dialogClassName="custom-onboarding-modal tradesVerifiedInfoModal"
        show={true}
      >
        <Modal.Body className="tradesVerifiedInfoModalBody figma-drop-shadow">
          <button
            className="CrossIcon"
            type="button"
            onClick={() => {
              showNotificationToast("Trade(s) verified! 🚀", `Here's the link ${blockChainLink}`);

              if (onBoardingStartContext) {
                dispatch(resetOnBoardingStartContext());
                navigate(onBoardingStartContext, { replace: true });
                return;
              }
              setDisplayInfoModal(false);
            }}
          >
            <img alt="crossBlack" src={crossBlack} />
          </button>

          <div className="tradesVerifiedInfoContent">
            <h2 className="title">Trade(s) verified</h2>
            <p className="desc">Stored on the blockchain.</p>

            <ul className="infoList">
              <li>
                <span className="checkmark">
                  <img src={CheckIcon} alt="CheckIcon" />
                </span>
                Verified on blockchain:
                <Link to={blockChainLink} target="_blank" className="viewLink">
                  View
                </Link>
              </li>
              <li>
                <span className="checkmark">
                  <img src={CheckIcon} alt="CheckIcon" />
                </span>

                <span className="listWrap">
                  Blockchain transaction ID:
                  <br />
                  <span className="linkCopy">
                    {blockChainId}{" "}
                    <img
                    style={{ cursor: "pointer" }}
                      onClick={() => {
                        navigator.clipboard.writeText(blockChainId);
                        toastify("Copied");
                      }}
                      src={CopyIcon}
                      alt="CopyIcon"
                    />
                  </span>
                </span>
              </li>
              <li>
                <div>
                  <div className="d-flex gap-1">
                    <span className="checkmark">
                      <img src={CheckIcon} alt="CheckIcon" />
                    </span>
                    <div>
                      Public page with your verifications:{" "}
                      <Link
                        className="viewLink"
                        to={`/verifiedTrades/${user?.leaderCommunity ? user?.leaderCommunity.name : user?.tradeName}`}
                        target="_blank" >
                        View
                      </Link>
                      <br/>
                      (Link also available on your dashboard)
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div
            className="d-sm-flex justify-content-center align-items-center flex-column"
            style={{ gap: "20px" }}
          >
            <BubbleSvgButton
              className="NextBtn"
              text={"Verify more trade(s)"}
              type="button"
              variant="black"
              containerStyling={{
                justifyContent: "center",
              }}
              onClick={() => {
                setDisplayInfoModal(false);
                showNotificationToast("Trade(s) verified! 🚀", `Here's the link ${blockChainLink}`);
                
              }}
              mainDivStyle={{
                width: "275px",
                height: "55px",
              }}
            />

            <BubbleSvgButton
              className="Verify Performance"
              text={"Verify My Performance"}
              type="button"
              variant="black"
              containerStyling={{
                justifyContent: "center",
              }}
              onClick={() => {
              showNotificationToast("Trade(s) verified! 🚀", `Here's the link ${blockChainLink}`);

                if (location.pathname.includes("verifymyTrade")) {
                  setPaymentType("subscription");
                  setDisplayInfoModal(false);
                } else {
                  if(!(user?.verifiedmyTrade?.payment)){
                    toastify("Click on Start Button to Start Performance Verification", "error");
                    setCurrentPageTitle("Dashboard");
                    navigate("/leader/dashboard");
                    return;
                  }
                  navigate("/leader/verifiedPaymentBillingHistory");
                }
              }}
              mainDivStyle={{
                width: "275px",
                height: "55px",
              }}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default TradesVerifiedInfoModal;
